import React from "react";
import "./Rebate_Ratio_card.css";

function Rebate_Ratio_card() {
  const data = [
    { text: "1 level lower level commission rebate", value: "0.6%" },
    { text: "2 level lower level commission rebate", value: "0.18%" },
    { text: "3 level lower level commission rebate", value: "0.36%" },
    { text: "4 level lower level commission rebate", value: "0.0162%" },
    { text: "5 level lower level commission rebate", value: "0.00486%" },
    { text: "6 level lower level commission rebate", value: "0.001486%" },
  ];

  return (
    <section className="Rebate_Ratio_card">
      <div className="rebate-card">
        <div className="rebate-header">
          <h3>Rebate Level <span>L0</span></h3>
        </div>

        <div className="rebate-list">
          {data.map((item, index) => (
            <div className="rebate-item" key={index}>
              <div className="left">
                <span className="dot"></span>
                <p>{item.text}</p>
              </div>
              <span className="value">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Rebate_Ratio_card;